import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const initialState = {
  name: '',
  role: '',
  organizationId: '',
  organizationName: '',
  organizationAbbreviation: '',
  userInfo: {}
};

export default {
  state: { ...initialState },
  mutations,
  actions,
  getters
};
